import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TextField } from "@mui/material";
import TableSortLabel from "@mui/material/TableSortLabel";
import { AllProductsEnum } from '../../QuoteRequest/Content';
import { BOHServiceDistributionStyle } from './BOHServiceDistributionStyled';
import { red } from '@mui/material/colors';
import Typography from '@mui/material/Typography';

//NOTE : This component is used for BOH/PATHWAYS/GWQ/NPRTW, to display/save variation.
export const BOHServiceDistribution = ({ headers, rows, isEditable, onTextChange, components, productId, BOHEditErrors }) => {


    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState("countryName");

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getUtilValue(countryId) {
        const countryQuoteDetail = rows?.filter((quoteDetail) => quoteDetail.countryId === countryId)[0];
        const ratePerHour = countryQuoteDetail?.rate;
        const isError = BOHEditErrors?.includes(countryId);
        if (isEditable) {
            return (
                < TextField name={countryQuoteDetail?.countryId}
                    onChange={(e) => onTextChange(countryQuoteDetail?.countryId, e.target.value)}
                    className="serviceDistributionInput"
                    value={ratePerHour}
                    size="small" required />
            )
        } else {
            return Number(Number(ratePerHour)?.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 });
        }
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array?.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }
    return (
        <BOHServiceDistributionStyle>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 400 }} aria-label="customized table">

                    <TableHead>
                        <TableRow>
                            {headers.map((header) => (

                                <TableCell key={header.id}>{header.label}</TableCell>
                            ))}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stableSort(rows, getComparator(order, orderBy)).map((row) => (
                            <TableRow key={row.countryId}>

                                <TableCell sx={{ fontWeight: 600 }}>{row.countryName}</TableCell>
                                {productId === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS && (
                                    <TableCell>{components}</TableCell>
                                )}
                                {productId === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS && (
                                    <TableCell>{
                                        Number(row.hoursPerCountry?.toFixed(2)).toLocaleString(
                                            "en",
                                            { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                        )
                                    }</TableCell>
                                )}
                                <TableCell>{row.headCount?.toLocaleString("en", { useGrouping: true })}</TableCell>
                                <TableCell>{row.rateCurrency}</TableCell>

                                {/*Editable Rate Per Hour*/}
                                <TableCell>{
                                    getUtilValue(row.countryId)

                                }
                                    {BOHEditErrors?.includes(row.countryId) &&
                                        < Typography variant="caption" sx={{ color: red[500], fontSize: '10px', whiteSpace: 'nowrap' }} display="block" gutterBottom>
                                            enter a valid number!
                                        </Typography>}
                                </TableCell>

                                <TableCell>{row.requestedCurrency + " " + (Number(row.rateRequestedCurrency?.toFixed(2)).toLocaleString(
                                    "en",
                                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                ))
                                }</TableCell>
                                <TableCell>{row.requestedCurrency + " " + (Number(row.revenueStage1ReqCurrency?.toFixed(2)).toLocaleString(
                                    "en",
                                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                ))
                                }</TableCell>
                                <TableCell>{row.requestedCurrency + " " + (Number(row.revenueStage2ReqCurrency?.toFixed(2)).toLocaleString(
                                    "en",
                                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                ))
                                }</TableCell>
                                <TableCell>{row.requestedCurrency + " " + (Number(row.revenueStage3ReqCurrency?.toFixed(2)).toLocaleString(
                                    "en",
                                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                ))
                                }</TableCell>
                                <TableCell>{row.requestedCurrency + " " + (Number(row.revenueStage4ReqCurrency?.toFixed(2)).toLocaleString(
                                    "en",
                                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                ))
                                }</TableCell>
                                <TableCell>{row.requestedCurrency + " " + (Number(row.revenueStage5ReqCurrency?.toFixed(2)).toLocaleString(
                                    "en",
                                    { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }
                                ))
                                }</TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </BOHServiceDistributionStyle>
    );
};

export default BOHServiceDistribution;